﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';

@Component({
  selector: 'app-utm-common-login',
  templateUrl: './utm-common-login.component.html',
  styleUrls: ['./utm-common-login.component.css']
})
export class UTMCommonLoginComponent implements OnInit {
  form: FormGroup;
  public role: any;
  public urn: any;
  public entityType: any;
  //public user: any;
  public userName: any;
  public readonly: boolean = false;
  public OTP_clicked: boolean = false;
  public showGenerateOTP: boolean = false;
  login1: any;
  homeRole: boolean = false;
  mobilenumber: any;
  URNorEntityID: any
  errorUser: boolean = false;
  errorOtp: boolean = false;
  errorReg: boolean = false;
  modifyUrl: boolean = false;
  ui2Url: boolean = false;
  EntityId: any;
  Entity_Name: any;
  Entity_Ref_No: any;
  Entity_User_Name: any;
  Entity_Org: any;
  E_Org_Name: any;
  Entity_EmailID: any;
  mob: any;
  roleSelected: any;
  hide = true;
  commonLoginForm: FormGroup;
  submitted: boolean = false;
  signFlag: boolean = true;
  public loginFlag = false;
  hideMobileNum: any;
  MobileNumber: any;
  errorRefFlag: any;
  errorRefMsg: any;
  errorOtpexpired: boolean;
  entityStatus: any;
  blacklisted: any;
  InactiveEntity: boolean;
  blacklistedEntity: boolean;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private db: $DBManagerService,
    private ls: APILoginService,
    private es: APIEntityService,
    private _route: ActivatedRoute,
    private $modal: $ModalManagerService,
    private evt: $BroadcastManagerService) {
    this._route.params.subscribe((params) => {
      //this.roleSelected = params['role'];
      this.Entity_Ref_No = ""

    })
  }

  ngOnInit() {
    this.commonLoginForm = this.formBuilder.group({
      ID: ['', [Validators.required]],
      otp: ['', []]
    });

  }




  get f() {
    return this.commonLoginForm.controls;
  }

  //On click Sing in button 
  // SignIn() {

  //   var unamev = this.commonLoginForm.get('ID').value;

  //  if (unamev == "") {
  //     alert("Please enter Entity ID");
  //   }


  //   this.submitted = true;
  //   if (this.commonLoginForm.invalid) {
  //     return;
  //   }
  //   else {      
  //       // this.URNorEntityID = "EntityID"

  //     var data = {   
  //       "ID": btoa(this.f.ID.value), //BTOA
  //           };
  //     this.loginAPI(data) // functions to validate credentials  
  //   }
  // }

  //Check username, Pwd from mongo
  // loginAPI(data) {
  //   this.ls.loginutm(data)
  //     .subscribe((r) => {
  //       if (r.message == "Success") {

  //         if (r.entityObj.Entity_Status == 'R') {
  //           this.errorRefFlag = true
  //           this.errorRefMsg = "The registration request has got rejected and details have been sent to your registered email ID."
  //           return
  //         } else if (r.entityObj.Entity_Status == 'D') {
  //           this.errorRefFlag = true
  //           this.errorRefMsg = "The registration request has got auto cancelled, as we have not received the required inputs within the stipulated time."
  //           return
  //         }
  //         else  {
  //           this.readonly = true;
  //           this.entityStatus = r.entityObj.Entity_Status;
  //           this.blacklisted = r.entityObj.Entity_BlackList_Status
  //           this.userName = r.entityObj.Entity_AuthSignName
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, this.userName);
  //           //this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, r.entityObj.Entity_ID);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN, r.entityObj.Entity_Ref_No);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_NAME, r.entityObj.Entity_AuthSignName);
  //           //this.db.set(Constants.SESSSION_STORAGE, Constants.USER_NAME, r.entityObj.Entity_AuthSignName);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_NAME, r.entityObj.E_Org_Name);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME, r.entityObj.Entity_AuthSignName);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_TYPE, r.entityObj.E_Org_Type);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ADDR, r.entityObj.Entity_Addr);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS, r.entityObj.Entity_Class);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.Hash_KYC_Doc, r.entityObj.Hash_KYC_Doc);
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.Entity_EmailID, atob(r.entityObj.Entity_EmailID)); //ATOB
  //           this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_MOBILE_NO, atob(r.entityObj.Entity_Mobile_No)); //ATOB

  //           this.db.set(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG, r.entityObj.Payment_Flag);  //Added for Entity-Payment 

  //           this.EntityId = r.entityObj.Entity_ID;
  //           this.Entity_Ref_No = r.entityObj.Entity_Ref_No;
  //           this.Entity_Name = r.entityObj.Entity_Name;
  //           this.Entity_User_Name = r.entityObj.Entity_User_Name;
  //           this.E_Org_Name = r.entityObj.E_Org_Name;
  //           this.Entity_EmailID = atob(r.entityObj.Entity_EmailID); //ATOB
  //           this.MobileNumber = atob(r.entityObj.Entity_Mobile_No); //ATOB
  //           this.errorReg = false;
  //           this.errorUser = false;
  //           this.roleSelected = r.entityObj.Entity_Class
  //           localStorage.setItem('currentUser', "user")
  //           this.showGenerateOTP = true;
  //           this.readonly = true;
  //           this.generateOTP();


  //       } 
  //     } else if (r.message == "IDNotFound") {
  //         this.errorRefFlag = true
  //         this.errorRefMsg = "ID is not exists in DLT!"
  //         return
  //       } else if (r.message == "Blacklisted") {
  //         this.errorRefFlag = true
  //         this.errorRefMsg = "Your ID is Blacklisted!"
  //         return
  //       } else if(r.message == "Inactive") {
  //         this.errorRefFlag = true
  //         this.errorRefMsg = "Your ID is Inactive!"
  //         return
  //       }  else if (r.message == "Invalid Entity ID ") {
  //         this.errorReg = false;
  //         this.errorUser = true;
  //         this.errorRefFlag = false;

  //       }
  //       else {
  //         this.errorUser = true;
  //         this.errorReg = false;
  //         this.errorRefFlag = false;
  //       }
  //     });
  // }

  // sending the otp to PE and RTM when username exists
  generateOTP() {

    // var otp = {
    //   "mobileNo": btoa(this.MobileNumber), //BTOA
    //   "email": btoa(this.Entity_EmailID) //BTOA
    // }
    var data = {
      "ID": this.commonLoginForm.get('ID').value

    }

    this.errorOtpexpired = false;
    this.errorOtp = false;
    this.InactiveEntity = false;
    this.blacklistedEntity = false;

    this.ls.utmgenerateOTP(data)
      .subscribe((r) => {
        if (r.message == "OTP successfully sent.") {
          this.signFlag = false
          // this.db.set(Constants.SESSSION_STORAGE, Constants.USERID_OTP, r.userid);

          this.OTP_clicked = true;
          this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_NAME,  r.entityObj[0].name);  
          // let hideMobile = [];
          // let mobile = this.MobileNumber || '';
          // let splitMobileNum = mobile.split("");
          // for (let i = 0; i <= splitMobileNum.length - 1; i++) {
          //   if (i == 0 || i == 1 || i == 2 || i == 3 || i == 4 || i == 5 || i == 6) {
          //     hideMobile.push('X');
          //   } else {
          //     hideMobile.push(splitMobileNum[i]);

          //   }
          // }
          // this.hideMobileNum = hideMobile.toString().replace(/\,/g, "");
        }
        else {
          if (r.message == "OTP expired") {
            this.errorOtpexpired = true;

          }
          else if (r.message == "OTP not matched") {
            this.errorOtp = true;
          }


          else if (r.message == "Already Registered with TATA")
            this.InactiveEntity = true;

          else if (this.blacklisted == true)
            this.blacklistedEntity = true;
        }      
      })
}
// isURNCheck: boolean = false;
// focusOutFunction() {
//   var data = this.commonLoginForm.get('ID').value;
//   let checkval = data.substring(0, 2)
//   if (data === undefined || data == "") {
//     this.isURNCheck = false;
//     return;
//   }
//   else {
//     this.isURNCheck = true;
//   }

// }

onSubmit() {

  this.homeRole = false;
  this.loginFlag = false;
  this.errorOtpexpired = false;
  this.errorOtp = false;
  this.InactiveEntity = false;
  this.blacklistedEntity = false;
  this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
  this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
  let data;
  data =
  {

    "OTP": btoa(this.f.otp.value),
    "ID": this.commonLoginForm.get('ID').value
  }


  console.log("----data--", data);

  this.ls.utmverifyOTP(data)
    .subscribe((r) => {
      if (r.message == "OTP Successfully Verified") {

        this.OTP_clicked = false
        this.homeRole = true;
        this.loginFlag = true;
        console.log("r.login", r.last_login)
        if (r.last_login) {
          this.db.set(Constants.SESSSION_STORAGE, Constants.LAST_LOGIN, r.last_login);
          this.login1 = this.db.get(Constants.SESSSION_STORAGE, Constants.LAST_LOGIN);
          console.log("In Constructor   ", this.login1)
        }
        this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
        this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
        this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.f.ID.value);

         
        
        this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE, 'TTBS–UTM');
        //Added for logout


        //this.db.set(Constants.SESSSION_STORAGE, Constants.ACCESS_TKN, r.accessToken);
        //this.db.set(Constants.SESSSION_STORAGE, Constants.REFRESH_TKN, r.refreshToken);

        this.evt.emit({ 'click': 'HEADER_EVENT' });
        this.evt.emit({ 'click': 'HEADER_EVENT_' });
        this.router.navigateByUrl('/petmbindinglist-tmtatdlist', { replaceUrl: true })

        // if (this.entityStatus == 'A' || this.entityStatus == 'C' || this.entityStatus == 'M1' || this.entityStatus == 'M2') {
        //   this.evt.emit({ 'click': 'HEADER_EVENT' });
        //   this.evt.emit({ 'click': 'HEADER_EVENT_' });
        //   this.router.navigateByUrl('/tmpe-modify-after-approval', { replaceUrl: true })
        // }

        // else if (this.entityStatus == 'R') {
        //   this.errorRefMsg = "The registration request has got rejected and details have been sent to your registered email ID."
        // }




      }
      else if (r.message == "Entity is already loggged in Please perform logout") {
        this.$modal.errorModal({
          title: 'Entity - Login',
          msg: "Entity is already logged in. Please perform log out"
        });
        this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.f.ID.value);

          this.ls.logOut(this.f.ID.value,"EntityID")
            .subscribe((r) => {
            console.log("r ", r)
            this.commonLoginForm.reset({ 'ID': '', 'password': '', 'otp': '', 'phoneNumber': '' })
            this.OTP_clicked = false;
            this.readonly = false;
            this.signFlag = true;
            this.router.navigateByUrl('/')
        })
     
      }
      else {
        this.homeRole = false;
        this.loginFlag = false;
        this.db.set(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG, this.loginFlag);
        this.db.set(Constants.SESSSION_STORAGE, Constants.HOME_ROLE, this.homeRole);
        this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.EntityId);
        if (r.message == "OTP expired") {
          this.errorOtpexpired = true;

        }
        else if (r.message == "OTP not matched") {
          this.errorOtp = true;
        }


        else if (r.message == "Already Registered with TATA")
          this.InactiveEntity = true;

        else if (this.blacklisted == true)
          this.blacklistedEntity = true;
      }
    })
}
}

